import { render, staticRenderFns } from "./callkey.vue?vue&type=template&id=5c62cc7d&scoped=true&"
import script from "./callkey.vue?vue&type=script&lang=js&"
export * from "./callkey.vue?vue&type=script&lang=js&"
import style0 from "./callkey.vue?vue&type=style&index=0&id=5c62cc7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62cc7d",
  null
  
)

export default component.exports